import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyhole2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconKeyhole2"><Path d="M12 2C15.866 2 19 5.13401 19 9C19 11.5125 17.675 13.7129 15.6895 14.9473L17.0537 19.0381C17.5394 20.495 16.4547 21.9999 14.9189 22H9.08105C7.54534 21.9999 6.46065 20.495 6.94629 19.0381L8.30957 14.9473C6.32437 13.7129 5 11.5122 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyhole2;
